import styled from 'styled-components';

import { breakpoints, colors, fontSizesByType, maxWidth } from 'theme';

export const ArticleSearchHeroTitle = styled.div<{ lineHeight?: number }>`
  font-size: ${fontSizesByType.h3[0]}px;
  @media (min-width: ${breakpoints[1]}) {
    font-size: ${fontSizesByType.h3[2]}px;
  }
`;

export const ArticleSearchHeroContainer = styled.div`
  width: 100%;
  max-width: 400px;
  margin: 0 auto;

  @media (min-width: ${breakpoints[1]}) {
    max-width: 622px;
  }

  @media (min-width: ${breakpoints[2]}) {
    max-width: ${maxWidth[2]}px;
  }
`;

export const ArticleSearchHeroWrapper = styled.div`
  padding: 40px;
  border-radius: 12px;
  box-shadow: 0 0 6px rgba(0, 0, 0, 0.3);
  background: ${colors.white};
  color: ${colors.mediumContentGrey};

  @media (min-width: ${breakpoints[3]}) {
    max-width: ${maxWidth[2]}px;
  }
`;
